import SparkMD5 from 'spark-md5';

const CHUNK_SIZE = 2 * 1024 * 1024;

// base64 MD5 that ActiveStorage direct-upload presign expects. Garage recomputes
// the MD5 on the presigned PUT and rejects BadDigest on mismatch. Web Crypto omits
// MD5, so stream-hash with spark-md5 in 2 MB chunks (no OOM on large files).
export const computeUploadChecksum = async (file: File): Promise<string> => {
  const spark = new SparkMD5.ArrayBuffer();
  for (let offset = 0; offset < file.size; offset += CHUNK_SIZE) {
    const buf = await file.slice(offset, offset + CHUNK_SIZE).arrayBuffer();
    spark.append(buf);
  }
  return btoa(spark.end(true));
};
